import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {HttpService} from './http.service';
import {AccessoryLocal} from '../model/accessory-local';
import {FindHttpError} from '../error/find-http-error';
import {HttpError} from '../error/http-error';
import { ArgosState } from '../../core/argos-state';
import { NgRedux } from '@angular-redux/store';

@Injectable()
export class AccessoryLocalService {
  private static ACCESSORY_LOCAL_ENDPOINT = '/accessoryLocal';

  private FIND_LOCALS = `${AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT}/findList`;
  private FIND_BY_NAME = `${AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT}/findByName`;
  private FIND_BY_NAME_CONTAINS = `${AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT}/findByNameContains`;
  private FIND_BY_FILTER = `${AccessoryLocalService.ACCESSORY_LOCAL_ENDPOINT}/findByFilter`;

  find$: Observable<any>;
  findLocalToMove$: Observable<Array<AccessoryLocal>>;
  error$: Observable<HttpError>;

  private findSubject: Subject<any>;
  private findLocalToMoveSubject: Subject<Array<AccessoryLocal>>;
  private errorSubject: Subject<HttpError>;

  constructor(private _httpService: HttpService,
              private ngRedux: NgRedux<ArgosState>) {
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.findLocalToMoveSubject = new Subject();
    this.findLocalToMove$ = this.findLocalToMoveSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  findByNameContains(name: string, pageNumber: number, pageSize: number) {
    this.subscribeToFindList(
      this._httpService.get(`${this.FIND_BY_NAME_CONTAINS}/${name}?pageNumber=${pageNumber}&pageSize=${pageSize}`, Array, FindHttpError));
  }

  findLocals(pageNumber: number, pageSize: number) {
    this.subscribeToFindList(
      this._httpService.get(`${this.FIND_LOCALS}?pageNumber=${pageNumber}&pageSize=${pageSize}`, Array, FindHttpError));
  }

  findByName(name: string, localType: string) {
    this.subscribeToFindList(
      this._httpService.get(`${this.FIND_BY_NAME}/${name}?localType=${localType}`, AccessoryLocal, FindHttpError));
  }

  findByNameIgnoreLocal(name: string, pageNumber: number, pageSize: number, ignoredId: number, localType: string) {
    this._httpService.get(`${this.FIND_BY_NAME_CONTAINS}/${name}?pageNumber=${pageNumber}&pageSize=${pageSize}`, Array, FindHttpError)
      .subscribe(
        locals => this.findLocalToMoveSubject.next(locals),
        error => this.errorSubject.next(error)
      );
  }

  private subscribeToFindList(observable) {
    observable
      .subscribe(
        locals => this.findSubject.next(locals),
        error => this.errorSubject.next(error)
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/accessory-local.service.ts